import {
  FETCH_ASSETS,
  FETCH_NEXT_ASSETS,
  FETCH_ASSET,
  INITIALIZE_ASSETS
} from "constants/ActionTypes";
import { INITIAL_STATE } from "constants/AppConstants";

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_ASSETS:
      return { ...state, assets: [...action.payload] };
    case FETCH_ASSET:
      return {
        ...state,
        asset: { ...action.payload }
      };
    case FETCH_NEXT_ASSETS:
      return { ...state, next_assets: { ...action.payload } };
    case INITIALIZE_ASSETS:
      return { ...state, assets: [] };
    default:
      return state;
  }
};
